import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import PrefixTab from "./Tabs/prefix";
import DetailTab from "./Tabs/detail";
import handleChangeWebsiteTab from "../../../../commons/ChangeWebsiteTab";

export default function SetAssignPrefixNumber() {
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        prefix: "กำหนดอักษรนำหน้าเลขที่เอกสาร",
        details: "รายละเอียดเลขที่เอกสาร"
      }
    });
  };

  useEffect(() => handleChangeTab(state || "prefix"), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Assign Prefix Document Number Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey="prefix"
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="prefix" title="กำหนดอักษรนำหน้าเลขที่เอกสาร">
            {websiteName === "กำหนดอักษรนำหน้าเลขที่เอกสาร" && <PrefixTab />}
          </Tab>

          <Tab eventKey="details" title="รายละเอียดเลขที่เอกสาร">
            {websiteName === "รายละเอียดเลขที่เอกสาร" && <DetailTab />}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
